"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _loadingSpinner = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/loading-spinner"));

require("./data-collection-10dlc.scss");

var _faq = _interopRequireDefault(require("../faq"));

var _intro = _interopRequireDefault(require("../intro"));

var _summary = _interopRequireDefault(require("../summary"));

var _form = _interopRequireDefault(require("../form"));

var _utils = require("../../utils");

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DataCollection10DLC = function DataCollection10DLC(_ref) {
  var _dropdownValues;

  var data = _ref.data,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
      _ref$failed = _ref.failed,
      failed = _ref$failed === void 0 ? false : _ref$failed,
      isFetching = _ref.isFetching,
      isSubmitting = _ref.isSubmitting,
      lookups = _ref.lookups,
      onSave = _ref.onSave,
      onSubmit = _ref.onSubmit,
      onResetCallState = _ref.onResetCallState,
      success = _ref.success,
      _ref$showReadOnlySumm = _ref.showReadOnlySummary,
      showReadOnlySummary = _ref$showReadOnlySumm === void 0 ? false : _ref$showReadOnlySumm,
      _ref$hideFAQ = _ref.hideFAQ,
      hideFAQ = _ref$hideFAQ === void 0 ? false : _ref$hideFAQ;

  if (!data) {
    console.error('No data object passed to the 10DLC form');
  }

  var submitStatus = data.submitStatus;
  var isLoading = isFetching || !submitStatus || !lookups; // making sure both calls are done

  var hasSavedDraft = submitStatus === 'DRAFT';
  var hasSubmitted = submitStatus === 'PENDING';
  var isUnsubmitted = submitStatus === 'UNSUBMITTED'; // we don't have a UI to handle what happens after they go
  // into these statuses yet so we just show the summary

  var submissionBeingProcessed = submitStatus === 'INPROCESS' || submitStatus === 'SUCCESS' || submitStatus === 'FAILED';

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEditingForm = _useState2[0],
      setIsEditingForm = _useState2[1];

  var canShowSummary = !isUnsubmitted && (hasSavedDraft || hasSubmitted) || submissionBeingProcessed;

  var _useState3 = (0, _react.useState)(!isLoading && canShowSummary),
      _useState4 = _slicedToArray(_useState3, 2),
      showSummary = _useState4[0],
      setShowSummary = _useState4[1];

  var dropdownValues = (_dropdownValues = {}, _defineProperty(_dropdownValues, _constants.LOOKUP_KEY_BUSINESS_TYPE, lookups && (0, _utils.getLookupValuesForDropdown)(_constants.LOOKUP_KEY_BUSINESS_TYPE, lookups)), _defineProperty(_dropdownValues, _constants.LOOKUP_KEY_BUSINESS_VERTICAL, lookups && (0, _utils.getLookupValuesForDropdown)(_constants.LOOKUP_KEY_BUSINESS_VERTICAL, lookups)), _defineProperty(_dropdownValues, _constants.LOOKUP_KEY_STOCK_EXCHANGE, lookups && (0, _utils.getLookupValuesForDropdown)(_constants.LOOKUP_KEY_STOCK_EXCHANGE, lookups)), _dropdownValues);
  (0, _react.useEffect)(function () {
    if (success && canShowSummary) {
      setShowSummary(true);
      setIsEditingForm(false);
    }
  }, [success, canShowSummary]);
  (0, _react.useEffect)(function () {
    if (isEditingForm) {
      onResetCallState();
    } // eslint-disable-next-line

  }, [isEditingForm]);
  return (
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "".concat(_constants.STYLE_BASE)
    },
    /*#__PURE__*/
    _react.default.createElement("section", {
      className: "".concat(_constants.STYLE_BASE, "_content")
    }, isLoading ?
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "".concat(_constants.STYLE_BASE, "_loadingSpinner")
    },
    /*#__PURE__*/
    _react.default.createElement(_loadingSpinner.default, null)) :
    /*#__PURE__*/
    _react.default.createElement(_react.default.Fragment, null, isEditingForm ?
    /*#__PURE__*/
    _react.default.createElement(_form.default, {
      data: data,
      errorMessage: errorMessage,
      failed: failed,
      dropdownValues: dropdownValues,
      isSubmitting: isSubmitting,
      hasSubmitted: hasSubmitted,
      onCancel: function onCancel() {
        return setIsEditingForm(false);
      },
      onSave: onSave,
      onSubmit: onSubmit
    }) : showSummary ?
    /*#__PURE__*/
    _react.default.createElement(_summary.default, {
      ctaAction: function ctaAction() {
        return setIsEditingForm(true);
      },
      data: data,
      dropdownValues: dropdownValues,
      hasSavedDraft: hasSavedDraft,
      hasSubmitted: hasSubmitted,
      showReadOnlySummary: showReadOnlySummary
    }) :
    /*#__PURE__*/
    _react.default.createElement(_intro.default, {
      showReadOnlySummary: showReadOnlySummary,
      onStartRegistration: function onStartRegistration() {
        return setIsEditingForm(true);
      }
    }))), !hideFAQ &&
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "".concat(_constants.STYLE_BASE, "_faq")
    },
    /*#__PURE__*/
    _react.default.createElement(_faq.default, null)))
  );
};

var _default = DataCollection10DLC;
exports.default = _default;